export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8517.c488cfc3.jpg";